export interface IProduct {
    id: string;
    image: string;
    is_new: boolean,
    part_name: string;
    price: number;
    quantity: number;
    url: string;
    manufacturer: string;
    brand: string;
    model: string;
    is_national: boolean;
    description: string;
    product_code: string;
    uuid: string;
}

export interface DataResponse {
    success?: boolean;
    response?: Array<IProduct>;
    description?: Array<string>
}

export enum ActionType {
    DELETE = 'DELETE',
    STOCK = 'STOCK',
}